export const Logo = ({ dark = false }) => (
  <span className="inline-flex items-center gap-3" data-testid="brand-logo">
    <svg width="34" height="34" viewBox="0 0 64 64" fill="none" aria-hidden="true">
      <rect width="64" height="64" rx="16" fill={dark ? "#FBF8F3" : "#201B17"} />
      <path
        d="M20 46V32a12 12 0 0 1 24 0v14"
        fill="none"
        stroke="#C4623C"
        strokeWidth="4"
        strokeLinecap="round"
      />
      <circle cx="32" cy="31" r="4" fill="#E3A387" />
      <path d="M15 52h34" stroke={dark ? "#201B17" : "#FBF8F3"} strokeWidth="4" strokeLinecap="round" />
    </svg>
    <span
      className={`font-serif-display text-xl leading-none ${
        dark ? "text-[#FBF8F3]" : "text-[#201B17]"
      }`}
    >
      <span className="tracking-[0.08em]">ALMAH</span>{" "}
      <em className="text-[#C4623C]">stays</em>
    </span>
  </span>
);
